import React, { useState } from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Check, Close } from "@mui/icons-material";
import { Chip, Stack } from "@mui/material";

import { GenericOverview } from "../components/core/GenericOverview";
import {
    getEmptyServiceToken,
    ServiceTokenEdit,
} from "../components/ServiceToken/ServiceTokenEdit";
import { IServiceToken, SERVICE_SCOPES } from "../interfaces/IServiceToken";

export const ServiceTokens: React.FC = () => {
    const [editToken, setEditToken] = useState(getEmptyServiceToken());
    const [currentArray, setCurrentArray] = useState<IServiceToken[]>([]);

    const columns: GridColDef[] = [
        { field: "id", headerName: "Nr.", width: 80 },
        { field: "name", headerName: "Bezeichnung", flex: 1 },
        {
            field: "scopes",
            headerName: "Berechtigungen",
            width: 230,
            renderCell: (params: GridRenderCellParams<any, string>) => (
                <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", height: "100%" }}>
                    {(params.value || "")
                        .split(",")
                        .map(x => x.trim())
                        .filter(x => x !== "")
                        .map(scope => (
                            <Chip
                                key={`scope-${params.id}-${scope}`}
                                size="small"
                                label={
                                    SERVICE_SCOPES.find(x => x.value === scope)?.title ?? scope
                                }
                            />
                        ))}
                </Stack>
            ),
        },
        {
            field: "can_write",
            headerName: "Schreiben",
            width: 110,
            renderCell: (params: GridRenderCellParams<any, boolean>) =>
                params.value ? <Check /> : <Close />,
        },
        {
            field: "is_active",
            headerName: "Aktiv",
            width: 90,
            renderCell: (params: GridRenderCellParams<any, boolean>) =>
                params.value ? <Check /> : <Close />,
        },
        {
            field: "last_used_at",
            headerName: "Zuletzt genutzt",
            width: 170,
            valueGetter: (value) =>
                value ? new Date(value).toLocaleString("de-DE") : "–",
        },
    ];

    return (
        <GenericOverview
            title="API-Token"
            btnTitle="Neues Token"
            columns={columns}
            editObject={editToken}
            setEditObject={setEditToken}
            currentArray={currentArray}
            setCurrentArray={setCurrentArray}
            fetchUrl="/servicetoken/"
            getEmptyObject={getEmptyServiceToken}
            enableDialog
            dialogWidth="md"
        >
            <ServiceTokenEdit
                key={`servicetoken-${editToken.id}`}
                currentToken={editToken}
                setCurrentToken={setEditToken}
            />
        </GenericOverview>
    );
};
